import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {createAndObserveIntersection} from '../../helpers/createAndObserveIntersection';

@Component({
    selector: 'app-select-input',
    templateUrl: './select-input.component.html',
    styleUrls: ['./select-input.component.scss'],
    standalone: false
})
export class SelectInputComponent implements OnInit, OnChanges, AfterViewInit {
  /**
   * for array of objects use formatter to choose which values you want to display ['title', 'subtitle', 'image', 'id']
   */
  @Input('formatter') valuesToShow;
  @Input() options: Array<any>;
  @Input() previewSelected: boolean;
  @Input() selectFirst: boolean;
  @Input() error: boolean;
  @Input() searchMode: boolean;
  @Input() setSearchTerm: boolean;
  @Input() placeholderText;
  @Input() initialOption = null;
  @Input() detectScrollToEnd = false;
  @Output() onOptionSelected = new EventEmitter();
  @Output() searchTermChanged = new EventEmitter<string>();
  @ViewChild('endOfList') endOfList: ElementRef;
  @Output() scrolledToEnd = new EventEmitter<boolean>();
  @Input() disabledText = 'Disabled';
  @Input() disabled = false;
  searchTerm: string;

  selected;
  open = false;
  formatted;

  ngOnInit(): void {
    if (this.setSearchTerm && this.initialOption) {
      this.searchTerm = this.initialOption.title;
    }
    if (this.selectFirst && this.options && !this.disabled) {
      if (this.initialOption) {
        this.selected = this.options[parseInt(this.initialOption)];
        this.onOptionSelected.emit(this.selected);
      } else {
        this.selected = this.options[0];
        this.onOptionSelected.emit(this.selected);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.valuesToShow && this.options) {
      this.selected = this.valuesToShow;
      this.formatValues();
    }
  }

  ngAfterViewInit(): void {
    if (this.detectScrollToEnd) {
      createAndObserveIntersection(this.endOfList).subscribe(isVisible => {
        if (isVisible) {
          this.scrolledToEnd.emit(true);
        }
      });
    }
  }

  formatValues() {
    this.formatted = JSON.parse(JSON.stringify(this.options)).map(opt => {
      return {
        title: this.valuesToShow[0] ? opt[this.valuesToShow[0]] : opt.name,
        subtitle: this.valuesToShow[1] ? opt[this.valuesToShow[1]] : null,
        image: this.valuesToShow[2] ? opt[this.valuesToShow[2]] : opt.thumbnail,
        id: this.valuesToShow[3] ? opt[this.valuesToShow[3]] : opt.id,
      };
    });
  }

  onSelectClick(e: MouseEvent) {
    if (this.disabled) {
      e.stopPropagation();
      return;
    }
    this.open = true;
  }

  selectOption(e: any, option: any, emit = true) {
    if (e) {
      e.stopPropagation();
    }

    const isUserAction = !!e;

    if ((isUserAction && this.disabled) || option?.disabled) {
      return;
    }

    this.searchTerm = option?.title ? option.title : option;
    this.open = false;
    this.selected = option;

    const originalValue = this.options ? this.options.find(elem => elem.id === option.id) : null;

    if (emit) {
      this.onOptionSelected.emit(option?.id ? originalValue : option);
    }
  }

  removeSelected(item?) {
    this.searchTerm = '';

    if (!item) {
      return (this.selected = null);
    }

    this.selected.splice(this.selected.indexOf(item), 1);
    this.onOptionSelected.emit(this.selected);
  }
}
